import { Category } from 'models/category';
import { isCategorySomeDepartment } from './categoryHelpers';

const isSale = (urlQueryParams): boolean => {
  return urlQueryParams && urlQueryParams.on_sale === '1';
};

const isNewIn = (urlQueryParams): boolean => {
  return urlQueryParams && Object.keys(urlQueryParams).length === 1 && urlQueryParams.sort_field === 'insert_time';
};

export const isEmptyGeneralCategory = (selectedCategory: Category): boolean => {
  return !selectedCategory || isCategorySomeDepartment(selectedCategory.name);
};

export const isEmptyGeneralCategoryNewInSale = ({
  selectedCategory,
  urlQueryParams,
}: {
  selectedCategory: Category;
  urlQueryParams: Record<string, string | string[]>;
}): boolean => {
  return isEmptyGeneralCategory(selectedCategory) || isSale(urlQueryParams) || isNewIn(urlQueryParams);
};
